module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"added":"As mídias foram adicionadas à seleção","add-to-selection":"Salvar seleção","add-to-collection-label":"Eu quero","selected":"foto(s)"}}')
  delete Component.options._Ctor
}
